import { Layout } from "components/Layout";

export default function ProgramsCorporatePage() {
  return (
    <Layout>
      <h1>ProgramsCorporatePage</h1>
    </Layout>
  );
}
